import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import SimpleAdmin from "./admin/SimpleAdmin";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<SimpleAdmin />} />{" "}
        <Route path="/" element={<App />} />{" "}
      </Routes>{" "}
    </Router>
  );
};

export default AppRouter;
